import React, { useEffect } from 'react';
import './FeaturesCarousel.scss';
import StarLogo from '../../../assets/images/attributes-decorator.svg';
import { GET_HOMEPAGE_CAROUSEL } from '../../../graphql/queries/homepageCarousel';
import { useQuery } from '@apollo/client';

interface IFeatureCarousel {
	attributes: string[];
}

export default function FeaturesCarousel() {
	const [getCarouselData, setCarouselData] = React.useState<IFeatureCarousel>({
		attributes: []
	});

	const { data, error } = useQuery(GET_HOMEPAGE_CAROUSEL);
	if (error) console.log('Cannot load carousel data');

	useEffect(() => {
		if (data?.homePageCarousel) {
			setCarouselData({
				attributes: Array.isArray(data.homePageCarousel)
					? data.homePageCarousel
					: data.homePageCarousel.attributes ?? []
			});
		}
	}, [data]);

	const attributes = getCarouselData?.attributes ?? [];
	const repeat = attributes.length === 1 ? 10 : 5;

	return (
		<>
			{attributes && attributes.length != 0 && (
				<div className='homepage-carousel'>
					<div className='slider-features'>
						<div className='group'>
							{[...Array(repeat)].map((_, i) => (
								<React.Fragment key={`group_${i}`}>
									{attributes.map((attr, j) => (
										<React.Fragment key={`certification_${i}_${j}`}>
											<div className='attribute'>{attr}</div>
											<img src={StarLogo} alt='img' />
										</React.Fragment>
									))}
								</React.Fragment>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
}
